import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GaleriaService } from '../../../../providers/galeria.service';

@Component({
  selector: 'app-subir-video-galeria-dialog',
  templateUrl: './subir-video-galeria-dialog.component.html',
  styleUrls: ['./subir-video-galeria-dialog.component.scss']
})
export class SubirVideoGaleriaDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  src: string;

  constructor(
    public dialog: MatDialogRef<SubirVideoGaleriaDialog>,
    public galeriaService: GaleriaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  onInput() {
    this.error = '';
  }

  onCancelar(): void {
    this.dialog.close();
  }

  onEnviar(): void {
    if (!this.src) {
      this.error = 'La url es requerida';
      return;
    } else {
      this.error = '';
    }

    this.cargando = true;
    this.galeriaService.guardarVideoGaleria(
      this.src
    ).subscribe(
      respuesta => {
        if (respuesta) {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            this.dialog.close();
          } else {
            this.error = respuesta.mensaje;
          }
        } else {
          this.error = "Ocurrió un error al guardar";
        }

        this.cargando = false;
      },
      () => {
        this.error = "Ocurrió un error al guardar";
        this.cargando = false;
      }
    );
  }
}
